import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { User } from '@/types/user';

export const getUserByEmail = async (email: string): Promise<ApiResult<User>> => {
  const { status, result } = await callApi<User>(
    `users/${email}`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
